import React from 'react';
import { Box, Card, CardHeader, CardMedia, CardContent, IconButton, Typography, Avatar, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import LinkIcon from '@mui/icons-material/Link';
import SkillIcon from '@mui/icons-material/Build';
import { useMediaQuery } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import WestSharpIcon from '@mui/icons-material/WestSharp';
import { buttonStyles } from '../utils/utils';

const certifications = [
  {
    title: 'Microsoft Certified: Azure Developer Associate',
    year: '2025',
    image: 'AzureDeveloperAssociate.jpg',
    logo: 'microsoft-logo.png',
    description:
    'Validated expertise in developing, deploying, and maintaining cloud applications on Microsoft Azure.',
  skills: [
    'Azure Services',
    'Azure DevOps',
    'Observability',
    'Authentication & Authorization',
  ],
    link: 'https://learn.microsoft.com/api/credentials/share/en-us/AnjaliPutta-1484/CBB437555E0D753C?sharingId=B58917387D845039',
  },
  {
    title: 'Microsoft Certified: Azure Fundamentals',
    year: '2025',
    image: 'AzureFundamentals.jpg',
    logo: 'microsoft-logo.png',
    description:
      'Learned about Azure services, management & governance.',
    skills: ['Cloud Concepts', 'Azure Architecture & Services', 'Azure Management & Governance'],
    link: 'https://learn.microsoft.com/api/credentials/share/en-us/AnjaliPutta-1484/357FFFCF0D47D553?sharingId=B58917387D845039',
  },
  {
    title: 'Front End Development Libraries',
    year: '2024',
    image: 'FrontendDevelopmentLibraries.png',
    logo: 'freecodecamp.png',
    description:
      'Gained advanced knowledge in React, Redux, and front-end libraries to build interactive web applications.',
    skills: ['React', 'Redux', 'Bootstrap', 'jQuery', 'SASS'],
    link: 'https://www.freecodecamp.org/certification/fccf4d69079-3aee-4ad0-b8ae-beaed1e1c286/front-end-development-libraries',
  },
  {
    title: 'Responsive Web Design',
    year: '2024',
    image: 'ResponsiveWebDesignCertification.png',
    logo: 'freecodecamp.png',
    description:
      'Mastered the art of building responsive and accessible web designs using modern CSS techniques and HTML.',
    skills: ['HTML', 'CSS', 'Layouts', 'Psuedo selectors', 'Accessibility', 'Animation', 'Transforms'],
    link: 'https://www.freecodecamp.org/certification/fccf4d69079-3aee-4ad0-b8ae-beaed1e1c286/responsive-web-design',
  },
  {
    title: 'Foundational C# with Microsoft',
    year: '2024',
    image: 'MicrosoftCSharp.png',
    logo: 'freecodecamp.png',
    description:
      'Acquired foundational knowledge in C# programming, covering basics to advanced concepts for .NET applications.',
    skills: ['C#', '.NET', 'Visual Studio', 'OOPs', 'Exception Handling', 'Debugging'],
    link: 'https://www.freecodecamp.org/certification/fccf4d69079-3aee-4ad0-b8ae-beaed1e1c286/foundational-c-sharp-with-microsoft',
  },
];

const Certifications: React.FC<{ isSidebarOpen: boolean; }> = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const theme = useTheme<Theme>(); // Get the theme and ensure it is of type Theme
  const isLargerThanSmall = useMediaQuery(theme.breakpoints.up('sm'));
  const isLargerThanLarge = useMediaQuery(theme.breakpoints.up('lg'));

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        // p: isLargerThanMedium ? 4 : 2,
        // pl: !isSidebarOpen ? 5 : (isLargerThanMedium ? 5 : 2), 
        // p: isLargerThanSmall ? (isLargerThanLarge ? 12 : 10) : 6,
        p: 4,
        pb: 8,
        pl: isLargerThanSmall ? (isLargerThanLarge ? 12 : 8) : (isSidebarOpen? 3: 5),
        pr: isLargerThanSmall ? (isLargerThanLarge ? 12 : 8) : 3,
        backgroundColor: 'rgb(255, 253, 231, 0.7)',
        width: '100%',
        // flexGrow: 1,
        overflowY: 'auto',
        // background: 'transparent',
      }}
    >
      <Typography variant="h2" component="h2" sx={{ mb: 6, mt: 2, textAlign: 'center' }}>
        Certifications
      </Typography>
      {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 5 }}>
        <div>
          <Button
            sx={buttonStyles}
            variant="contained" color="primary" endIcon={<WestSharpIcon/>}
            onClick={() => handleNavigation('/work-experience')}>
            Work Experience
          </Button>
        </div>
      </Box> */}
      <Grid container spacing={{ xs: 3, sm: 5, md: 8 }}>
        {certifications.map((cert, index) => (
          <Grid
            size={{ xs: 12, sm: 10, md: 6, xl:4 }}
            key={index}
            // sx={{ backgroundColor: 'secondary.light' }}
            sx={{ background: 'transparent' }}
          >
            <Card
              sx={{
                // backgroundColor: '#FFA57D',
                backgroundColor: 'rgb(255, 165, 125, 0.7)',
                // webkitBackdropFilter: 'blur(5px)',
                // backdropFilter: 'blur(5px)',
                backdropFilter: 'opacity(50%)',
                webkitBackdropFilter: 'opacity(40%)',
              }}
            >
              <CardHeader
                // avatar={<SchoolIcon />}
                avatar={
                  <Avatar
                    src={cert.logo}
                    alt={cert.logo}
                    sx={{ width: 42, height: 42 }}
                  />
                }
                action={
                  <IconButton
                    aria-label="settings"
                    href={cert.link}
                    target="_blank"
                  >
                    <LinkIcon />
                  </IconButton>
                }
                title={cert.title}
                subheader={`Earned in ${cert.year}`}
                titleTypographyProps={{
                  variant: 'h6',
                  component: 'div',
                  sx: { fontWeight: 'bold' },
                }}
              />
              <CardMedia
                component="img"
                height="194"
                image={cert.image}
                alt={`${cert.title} Certification`}
                sx={{
                  objectFit: 'fill',
                  // minHeight: '280px',
                  minHeight: '14vw',
                }}
              />
              <CardContent>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: '550' }}
                >
                  {cert.description}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mt: 3, mb: 1, fontWeight: '700' }}
                >
                  Skillset
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {cert.skills.map(skill => (
                    <Box
                      key={skill}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        px: 1,
                        py: 0.5,
                        bgcolor: 'background.default',
                        borderRadius: 1,
                      }}
                    >
                      <SkillIcon sx={{ fontSize: 14, mr: 0.5 }} />
                      <Typography variant="caption">{skill}</Typography>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 10, mb: 2 }}>
        <div>
          <Button
            sx={buttonStyles}
            variant="contained" color="primary" endIcon={<WestSharpIcon/>}
            onClick={() => handleNavigation('/work-experience')}>
            Work Experience
          </Button>
        </div>
      </Box>
    </Box>
  );
};

export default Certifications;
